import React, { useRef, useEffect, useState } from "react";
import Select from "react-select";

function SelectDropdown({
  options,
  selectedOption,
  setSelectedOption,
  name,
  closeSelect,
  isDisable,
  preventKeyboardOpen,
  ...props
}) {
  const [isClient, setIsClient] = useState(false);
  const dateRangeRef = useRef();

  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    if (!isClient) return;

    const handleClickOutside = (event) => {
      if (
        closeSelect &&
        dateRangeRef.current &&
        !dateRangeRef.current.contains(event.target)
      ) {
        closeSelect();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isClient, closeSelect]);

  return (
    <div
      ref={dateRangeRef}
      style={{ width: "100%", minWidth: "100%", height: "100%" }}
      className={`${isDisable ? "disable" : ""}`}
    >
      {isClient && (
        <Select
          value={selectedOption}
          {...props}
          onChange={setSelectedOption}
          options={options || []}
          placeholder={`Select ${name}`}
          isClearable
          menuPortalTarget={document.body}
          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          isDisabled={isDisable}
          isSearchable={preventKeyboardOpen ? false : true}
        />
      )}
    </div>
  );
};

export default SelectDropdown;